import Radio from 'backbone.radio';
import BreadcrumbNavLayout from '@/views/breadcrumb_nav_layout';

    var globalCh = Radio.channel('global');

    function show_main_nav() {
        var active = globalCh.request('active_account');
        var app_layout = globalCh.request('app_layout');
        app_layout.showChildView('main_nav', new BreadcrumbNavLayout() );
        globalCh.request('changeActiveAccount', active, function() {
            globalCh.request('set_selection', {
                type: 'app',
                id: 'home'
            });
        });
     }
     export default show_main_nav;
